import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refEmailLogListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'trans_id', label: 'İşlem Kimliği', sortable: false },
    { key: 'to', label: 'Alıcı', sortable: true },
    { key: 'time', label: 'İşlem Zamanı', sortable: true },

    { key: 'response_str', label: 'İşlem Yanıtı Açıklaması', sortable: false },
    { key: 'event', label: 'Durum', sortable: true },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalEmailLogList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refEmailLogListTable.value ? refEmailLogListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEmailLogList.value,
    }
  })

  const refetchData = () => {
    refEmailLogListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchEmailCategories = (ctx, callback) => {
    store
      .dispatch('app-email/fetchEmailSendDetailRecords', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
        email_data_id: router.currentRoute.params.id,
      })
      .then(response => {
        const { data } = response.data.data
        const { total } = response.data.meta

        callback(data)
        totalEmailLogList.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching email log list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchEmailCategories,
    tableColumns,
    perPage,
    currentPage,
    totalEmailLogList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refEmailLogListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
